import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotfoundComponent } from './notfound/notfound.component';
import{ BlankComponent,CondensedComponent,CasualLayout, SimplyWhiteLayout }  from './@pages/layouts'
import {AuthGuard} from './_guards/auth.guard'
export const routes: Routes = [
 
  { path: 'lms',  component: SimplyWhiteLayout,loadChildren: () => import('./extra/extra.module').then(m => m.ExtraModule) },
  { path: 'admin',  component: SimplyWhiteLayout,loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
  { path: 'driver',  component: SimplyWhiteLayout,loadChildren: () => import('./driver/driver.module').then(m => m.DriverModule) },
  { path: 'trafico',  component: SimplyWhiteLayout,loadChildren: () => import('./trafico/trafico.module').then(m => m.TraficoModule) },
  { path: 'transportistas',  component: SimplyWhiteLayout,loadChildren: () => import('./transportistas/transportistas.module').then(m => m.TransportistasModule) },
  { path: 'camiones',  component: SimplyWhiteLayout,loadChildren: () => import('./camiones/camiones.module').then(m => m.CamionesModule) },
  { path: 'welcome',  component: SimplyWhiteLayout,loadChildren: () => import('./welcome/welcome.module').then(m => m.WelcomeModule) },
  { path: 'factura',  component: SimplyWhiteLayout,loadChildren: () => import('./factura/facturas.module').then(m => m.FacturasModule) },
  { path: 'widget',  component: SimplyWhiteLayout,loadChildren: () => import('./widget/witgets.module').then(m => m.WidgetModule) },


  // { path: 'console',  component: CondensedComponent,loadChildren: () => import('./console/console.module').then(m => m.ConsoleModule), canActivate:[AuthGuard],canLoad:[AuthGuard] },
  // { path: 'wms',  component: CondensedComponent,loadChildren: () => import('./wms/wms.module').then(m => m.ConsoleModule) },
  // { path: 'tracking',  component: CasualLayout,loadChildren: () => import('./tracking/tracking.module').then(m => m.ConsoleModule) },
  { path: 'login',  component: BlankComponent,loadChildren: () => import('./auth/auth.module').then(m => m.SessionModule) },
  { path: 'register',  component: BlankComponent,loadChildren: () => import('./auth/auth.module').then(m => m.SessionModule) },
  { path: 'smartreader',  component: SimplyWhiteLayout,loadChildren: () => import('./smartreader/smartreader.module').then(m => m.SmartreaderModule) },
  { path: '', redirectTo: 'console', pathMatch: 'full'},
  { path: '404', component:NotfoundComponent},
  { path: '**',redirectTo: '404',pathMatch: 'full'}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes)
	],
	exports: [RouterModule]
})
export class AppRoutingModule {}